import React, { useState } from 'react'
import { useOutletContext } from 'react-router-dom'

import MediaPdfsLayout from '../components/MediaPdfsLayout/MediaPdfsLayout'
import SafeBankingModal from '../components/SafeBanking/SafeBankingModal'
import ModalContent from '../components/SafeBanking/ModalContent'

const SafeBanking = () => {
  const { data, pagination } = useOutletContext() || {}
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState({})

  const handleView = (cardDetail) => {
    setOpenModal(true)
    setModalData(cardDetail)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  return (
    <>
      <MediaPdfsLayout
        data={data}
        pagination={pagination}
        onShow={handleView}
      />
      <SafeBankingModal open={openModal} setOpen={closeModal}>
        <ModalContent data={modalData} handleClose={closeModal} />
      </SafeBankingModal>
    </>
  )
}

export default SafeBanking
